<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>INPASSING NON PNS</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Inpassing</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.pangkat_golongan.$error}">
            <label> Pangkat Golongan </label>
            <j-input
              v-model="$v.data_master.pangkat_golongan.$model"
              placeholder="Pangkat Golongan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nomor_sk_inpassing.$error}">
            <label> Nomor SK Inpassing </label>
            <j-input
              v-model="$v.data_master.nomor_sk_inpassing.$model"
              type="number"
              placeholder="Nomor SK Inpassing"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tgl_sk_inpassing.$error}">
            <label> Tgl SK Inpassing </label>
            <j-datepicker
              v-model="$v.data_master.tgl_sk_inpassing.$model"
              placeholder="Tgl SK Inpassing"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tmt_sk_inpassing.$error}">
            <label> TMT SK Inpassing </label>
            <j-datepicker
              v-model="$v.data_master.tmt_sk_inpassing.$model"
              placeholder="TMT SK Inpassing"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.angka_kridit.$error}">
            <label> Angka Kridit </label>
            <j-input
              v-model="$v.data_master.angka_kridit.$model"
              type="number"
              placeholder="Angka Kridit"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masa_kerja_tahun.$error}">
            <label> Masa Kerja (Tahun) </label>
            <j-input
              v-model="$v.data_master.masa_kerja_tahun.$model"
              type="number"
              placeholder="Masa Kerja (Tahun)"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masa_kerja_bulan.$error}">
            <label> Masa Kerja (Bulan) </label>
            <j-input
              v-model="$v.data_master.masa_kerja_bulan.$model"
              type="number"
              placeholder="Masa Kerja (Bulan)"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Inpassing</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.pangkat_golongan.$error}">
            <label> Pangkat Golongan </label>
            <j-input
              v-model="$v.data_master.pangkat_golongan.$model"
              :disabled="readOnly"
              placeholder="Pangkat Golongan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nomor_sk_inpassing.$error}">
            <label> Nomor SK Inpassing </label>
            <j-input
              v-model="$v.data_master.nomor_sk_inpassing.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Nomor SK Inpassing"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tgl_sk_inpassing.$error}">
            <label> Tgl SK Inpassing </label>
            <j-datepicker
              v-model="$v.data_master.tgl_sk_inpassing.$model"
              :disabled="readOnly"
              placeholder="Tgl SK Inpassing"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tmt_sk_inpassing.$error}">
            <label> TMT SK Inpassing </label>
            <j-datepicker
              v-model="$v.data_master.tmt_sk_inpassing.$model"
              :disabled="readOnly"
              placeholder="TMT SK Inpassing"
              format="MMM dd, yyyy"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.angka_kridit.$error}">
            <label> Angka Kridit </label>
            <j-input
              v-model="$v.data_master.angka_kridit.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Angka Kridit"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masa_kerja_tahun.$error}">
            <label> Masa Kerja (Tahun) </label>
            <j-input
              v-model="$v.data_master.masa_kerja_tahun.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Masa Kerja (Tahun)"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.masa_kerja_bulan.$error}">
            <label> Masa Kerja (Bulan) </label>
            <j-input
              v-model="$v.data_master.masa_kerja_bulan.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Masa Kerja (Bulan)"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jInpassingNonPns',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['pangkat_golongan', 'nomor_sk_inpassing', 'tgl_sk_inpassing', 'tmt_sk_inpassing', 'angka_kridit', 'masa_kerja_tahun', 'masa_kerja_bulan'],
      options: {
        headings: {
          pangkat_golongan: 'PANGKAT GOLONGAN',
          nomor_sk_inpassing: 'NOMOR SK INPASSING',
          tgl_sk_inpassing: 'TGL SK INPASSING',
          tmt_sk_inpassing: 'TMT SK INPASSING',
          angka_kridit: 'ANGKA KRIDIT',
          masa_kerja_tahun: 'MASA KERJA (TAHUN)',
          masa_kerja_bulan: 'MASA KERJA (BULAN)',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['pangkat_golongan', 'nomor_sk_inpassing', 'tgl_sk_inpassing', 'tmt_sk_inpassing', 'angka_kridit', 'masa_kerja_tahun', 'masa_kerja_bulan'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListInpassing(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        pangkat_golongan: '',
        nomor_sk_inpassing: null,
        tgl_sk_inpassing: null,
        tmt_sk_inpassing: null,
        angka_kridit: null,
        masa_kerja_tahun: null,
        masa_kerja_bulan: null,
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createInpassing', 'updateInpassing', 'deleteInpassing']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        pangkat_golongan: '',
        nomor_sk_inpassing: null,
        tgl_sk_inpassing: null,
        tmt_sk_inpassing: null,
        angka_kridit: null,
        masa_kerja_tahun: null,
        masa_kerja_bulan: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        pangkat_golongan: '',
        nomor_sk_inpassing: null,
        tgl_sk_inpassing: null,
        tmt_sk_inpassing: null,
        angka_kridit: null,
        masa_kerja_tahun: null,
        masa_kerja_bulan: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        pangkat_golongan: param.row.pangkat_golongan,
        nomor_sk_inpassing: param.row.nomor_sk_inpassing,
        tgl_sk_inpassing: param.row.tgl_sk_inpassing,
        tmt_sk_inpassing: param.row.tmt_sk_inpassing,
        angka_kridit: param.row.angka_kridit,
        masa_kerja_tahun: param.row.masa_kerja_tahun,
        masa_kerja_bulan: param.row.masa_kerja_bulan,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        params.tgl_sk_inpassing = params.tgl_sk_inpassing ? this.$moment(params.tgl_sk_inpassing).format('YYYY-MM-DD') : '';
        params.tmt_sk_inpassing = params.tmt_sk_inpassing ? this.$moment(params.tmt_sk_inpassing).format('YYYY-MM-DD') : '';
        this.createInpassing(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        params.tgl_sk_inpassing = params.tgl_sk_inpassing ? this.$moment(params.tgl_sk_inpassing).format('YYYY-MM-DD') : '';
        params.tmt_sk_inpassing = params.tmt_sk_inpassing ? this.$moment(params.tmt_sk_inpassing).format('YYYY-MM-DD') : '';
        this.updateInpassing(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteInpassing(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        pangkat_golongan: { required },
        nomor_sk_inpassing: { required },
        tgl_sk_inpassing: { required },
        tmt_sk_inpassing: { required },
        angka_kridit: { required },
        masa_kerja_tahun: { required },
        masa_kerja_bulan: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jInpassingNonPns.vue